import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sg-success"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sg-success-icon" }, "✓", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sg-success-title" }, "提交成功", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sg-success-desc" }, "您的建议已提交，等待评审", -1 /* HOISTED */)
const _hoisted_5 = { class: "sg-success-id" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", null, "合理化建议", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "提出你的改进建议", -1 /* HOISTED */)
const _hoisted_8 = {
  key: 0,
  class: "sg-loading"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sg-spinner" }, null, -1 /* HOISTED */)
const _hoisted_10 = {
  key: 1,
  class: "sg-form"
}
const _hoisted_11 = { class: "sg-form-group" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "sg-form-label" }, [
  /*#__PURE__*/_createTextVNode("标题 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1 /* HOISTED */)
const _hoisted_13 = { class: "sg-form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "sg-form-label" }, [
  /*#__PURE__*/_createTextVNode("分类 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "sg-categories" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "sg-form-group" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "sg-form-label" }, [
  /*#__PURE__*/_createTextVNode("详细描述 "),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "*")
], -1 /* HOISTED */)
const _hoisted_19 = { class: "sg-form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "sg-form-label" }, "拍照上传", -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "sg-upload-icon" }, "📷", -1 /* HOISTED */)
const _hoisted_22 = { class: "sg-upload-text" }
const _hoisted_23 = {
  key: 0,
  class: "sg-image-list"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createCommentVNode(" 提交成功页面 "),
    ($setup.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, "建议编号：" + _toDisplayString($setup.submittedId), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "sg-form",
            style: {"margin-top":"24px"}
          }, [
            _createElementVNode("button", {
              class: "sg-btn sg-btn-primary",
              onClick: $setup.resetForm
            }, "再提一条"),
            _createElementVNode("button", {
              class: "sg-btn sg-btn-outline",
              style: {"margin-top":"12px"},
              onClick: $setup.viewMySuggestions
            }, "查看我的建议")
          ])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createCommentVNode(" 表单页面 "),
          _createElementVNode("div", {
            class: "sg-header",
            style: {"position":"relative"}
          }, [
            _createElementVNode("span", {
              class: "sg-navbar-back",
              style: {"position":"absolute","left":"16px","top":"50%","transform":"translateY(-50%)","color":"#fff"},
              onClick: $setup.goBack
            }, "‹"),
            _hoisted_6,
            _hoisted_7
          ]),
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createTextVNode(" 加载中... ")
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("input", {
                    class: "sg-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.title) = $event)),
                    placeholder: "请输入建议标题",
                    maxlength: "100"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.title]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.categories, (cat) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: cat,
                        class: _normalizeClass(["sg-category-tag", { active: $setup.selectedCategory === cat }]),
                        onClick: $event => ($setup.selectedCategory = cat)
                      }, _toDisplayString(cat), 11 /* TEXT, CLASS, PROPS */, _hoisted_16))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "sg-textarea",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.description) = $event)),
                    placeholder: "请详细描述您的建议内容...",
                    maxlength: "2000"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, $setup.description]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", {
                    class: "sg-upload-area",
                    onClick: $setup.triggerFileInput
                  }, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString($setup.uploading ? '上传中...' : '点击拍照或选择图片'), 1 /* TEXT */)
                  ]),
                  ($setup.images.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.images, (img, idx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "sg-image-item",
                            key: idx
                          }, [
                            _createElementVNode("img", {
                              src: img,
                              alt: "预览"
                            }, null, 8 /* PROPS */, _hoisted_24),
                            _createElementVNode("span", {
                              class: "sg-image-remove",
                              onClick: $event => ($setup.removeImage(idx))
                            }, "×", 8 /* PROPS */, _hoisted_25)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  class: "sg-btn sg-btn-primary",
                  disabled: $setup.submitting || $setup.uploading,
                  onClick: $setup.handleSubmit
                }, _toDisplayString($setup.submitting ? '提交中...' : '提交建议'), 9 /* TEXT, PROPS */, _hoisted_26)
              ]))
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}